import { Controller } from "@hotwired/stimulus"

// Removes the <img> from the DOM when its src fails to load.
// Used to layer a photo over an initials/placeholder element — if the
// photo loads, it covers the placeholder; if it fails, the placeholder
// shows through (instead of the browser's broken-image icon + alt text).
export default class extends Controller {
  connect() {
    if (this.element.complete && this.element.naturalWidth === 0) {
      this.hide()
    }
  }

  hide() {
    this.element.remove()
  }
}
